import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { Visualizer } from "./Visualizer";
export class Canvas {
  constructor() {
    this.mouse = { x: 0, y: 0 };
    this.targetCameraRotationX = 0;
    this.targetCameraRotationY = 0;
    this.cameraRotationX = 0;
    this.cameraRotationY = 0;

    this.createScene();
    this.createRenderer();
    this.createCamera();

    this.animate();
    this.createVisualizer();
    this.addEventListeners();
  }

  createVisualizer() {
    this.visualizer = new Visualizer(this.scene, this.camera);
  }

  createScene() {
    this.scene = new THREE.Scene();
  }

  createCamera() {
    this.camera = new THREE.PerspectiveCamera(
      75, // FOV
      window.innerWidth / window.innerHeight, // aspect ratio
      0.1, // near
      1000 // far
    );
    this.camera.position.z = 5;
  }

  createRenderer() {
    // === RENDERER ===
    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    document.body.appendChild(this.renderer.domElement);
  }

  animate() {
    requestAnimationFrame(() => this.animate());

    if (this.visualizer) {
      this.visualizer.animate();
    }

    this.cameraRotationX = THREE.MathUtils.lerp(
      this.cameraRotationX,
      this.targetCameraRotationX,
      0.05
    );
    this.cameraRotationY = THREE.MathUtils.lerp(
      this.cameraRotationY,
      this.targetCameraRotationY,
      0.05
    );

    // Appliquer la rotation à la caméra
    this.camera.rotation.x = this.cameraRotationX;
    this.camera.rotation.y = this.cameraRotationY;
    this.renderer.render(this.scene, this.camera);
  }

  addEventListeners() {
    window.addEventListener("resize", () => this.onResize());
    window.addEventListener("mousemove", (event) => this.onMouseMove(event));
  }

  onMouseMove(event) {
    const width = window.innerWidth;
    const height = window.innerHeight;

    this.mouse.x = (event.clientX / width) * 2 - 1;
    this.mouse.y = -(event.clientY / height) * 2 + 1;

    const maxRotation = 0.1;
    this.targetCameraRotationY = -this.mouse.x * maxRotation;
    this.targetCameraRotationX = this.mouse.y * maxRotation;
  }

  onResize() {
    if (this.camera && this.renderer) {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    }
  }
}
